import React, { useState, useEffect, useRef } from 'react';
import { Bubble, Justify, Form, Input, Button } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import * as service from '@/pages/home/services/login';
import { useIntl } from 'umi';
import { isValidCode, isEmptyValue } from '../_config/common';
import { EmailLoginCodeType } from '../_config/constant';
import { encryptedInfo } from '@/pages/home/utils/frontEncryption';

export default function EmailLoginCode(props: EmailLoginCodeType) {
  const {
    login14Days,
    verifyType,
    registerInfo,
    expires,
    valueEmail,
    valuePadssword,
    onLoginSuccess,
    onBack = () => console.log,
    onError = () => console.log,
  } = props;
  const { formatMessage, locale } = useIntl();
  const [statusCode, setStatusCode] = useState<string | null>(null);
  const [valueCode, setValueCode] = useState<string>('');
  const [successCode, setSuccessCode] = useState(false);
  const [currentExpires, setCurrentExpires] = useState(expires); // 邮件登陆后会给一个时间
  const [isDisabled, setIsDisabled] = useState(expires > 0); // 第一次来的已经发过一次邮件验证了
  const [loading, setLoading] = useState(false);
  const isEn = locale === 'zh-CN' ? 'zh' : 'en';
  const onCodeChangClick = (val: string) => {
    setValueCode(val);
  };
  const onCodeBuleClick = () => {
    if (isEmptyValue(valueCode)) {
      setStatusCode('dbh_login_no_access_code');
      setSuccessCode(false);
      return false;
    } else if (isValidCode(valueCode)) {
      setStatusCode(null);
      setSuccessCode(true);
      return true;
    } else {
      setStatusCode('dbh_login_no_access_code_format_error');
      setSuccessCode(false);
      return false;
    }
  };

  const timeRef = useRef<NodeJS.Timer>();

  useEffect(() => {
    timeRef.current = setInterval(() => {
      if (currentExpires <= 1) {
        clearInterval(timeRef.current);
        setIsDisabled(false);
      } else {
        setCurrentExpires(currentExpires - 1);
      }
    }, 1000);
    return () => {
      clearInterval(timeRef.current);
    };
  }, [currentExpires]);

  const handleGetEmailCode = async (e: any) => {
    e.preventDefault();
    try {
      const turnPassword = await encryptedInfo(valuePadssword || '');
      const params: any = {
        email: valueEmail,
        password: turnPassword,
      };
      if (verifyType === 'register') {
        // 注册页面参数
        params.isRegister = true;
      }
      const res: any = await service.getEmailCode(params);
      setCurrentExpires(res?.expired);
      setIsDisabled(true);
    } catch (err: any) {
      onError(err?.msg, err?.code);
    }
  };

  const handleVerify = async () => {
    if (loading) {
      return;
    }
    if (!onCodeBuleClick()) {
      return;
    }
    try {
      setLoading(true);
      const turnPassword = await encryptedInfo(valuePadssword || '');
      const params: any = {
        email: valueEmail,
        password: turnPassword,
        emailCode: valueCode,
        lang: isEn,
      };
      if (verifyType === 'register') {
        // 注册登陆时发注册成功邮件， 并且把注册信息带上
        params.isRegister = true;
        params.group_name = registerInfo?.group_name;
        params.reason = registerInfo?.reason;
        params.occupation = registerInfo?.occupation;
      }
      if (login14Days) {
        params.login14Days = true;
      }
      await service.verifyEmailCode(params);
      onLoginSuccess();
    } catch (err: any) {
      if (err?.code === 500) {
        // 500 fail
        setStatusCode('dbh_login_incorrenct_code_try_again');
        setSuccessCode(false);
      } else {
        onError(err?.msg, err?.code);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-cont-email">
      <div className="login-cont">
        <div className="login-cont-title">
          {formatMessage({
            id:
              verifyType === 'register'
                ? 'dbh_login_signup_for_free'
                : 'dbh_login_email_login',
          })}
        </div>

        <div className="login-cont-email-icon">
          <SvgIcon className="email-success" type="youjianchenggong" />
        </div>

        <div className="login-cont-email-exit">
          <div className="login-cont-email-txt">
            {formatMessage({ id: 'dbh_login_please_enter_emailed' })}
          </div>
          <div className="login-cont-email-address">{valueEmail}</div>

          <>
            <Form.Item
              label=""
              status={
                successCode ? 'success' : statusCode ? 'error' : undefined
              }
              message={
                statusCode ? formatMessage({ id: statusCode }) : undefined
              }
            >
              <Input
                placeholder={formatMessage({
                  id: 'dbh_login_enter_access_code',
                })}
                value={valueCode}
                onChange={(val) => {
                  onCodeChangClick(val);
                }}
                onBlur={onCodeBuleClick}
              />
            </Form.Item>
            <Justify
              left={
                isDisabled && (
                  <div className="login-cont-email-countdown">
                    {formatMessage({ id: 'dbh_login_code_expires_after' })}{' '}
                    <span>{currentExpires}s</span>
                  </div>
                )
              }
              right={
                <>
                  <Bubble
                    content={
                      isDisabled && (
                        <div className="login-cont-email-tips">
                          <SvgIcon className="true" type="zhengque" />
                          <span>
                            {formatMessage({
                              id: 'dbh_login_code_send_success',
                            })}
                          </span>
                        </div>
                      )
                    }
                  >
                    <Button
                      type="link"
                      className="login-cont-from-info"
                      disabled={isDisabled}
                      onClick={(e) => {handleGetEmailCode(e)}}
                    >
                      <span>
                        {formatMessage({ id: 'dbh_login_send_new_code' })}
                      </span>
                    </Button>
                  </Bubble>
                </>
              }
            ></Justify>
          </>
        </div>

        <div className="login-cont-from-btn">
          <Button type="primary" onClick={() => {handleVerify()}} loading={loading}>
            {formatMessage({ id: 'dbh_login_verify' })}
          </Button>
          <Button type="link" onClick={onBack}>
            {formatMessage({ id: 'dbh_login_goback_tologin' })}
          </Button>
        </div>
      </div>
    </div>
  );
}
